import CascateList from "../../../../../../common/components/cascate_list";
import PrimaryButton from "../../../../../../common/components/primary_button";
import { DefaultDateRangePickerInput } from "../../../../../../common/components/default_date_range_picker_input";
import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import { DropDown } from "../../../../../../common/domain/models/dropdown";
import { DefaultMultiAutocomplete } from "../../../../../../common/components/default_multi_autocomplete";
import { MaskedInput } from "../../../../../../common/components/masked_inputs/masked_input";

type Props = {
  ddlFuncionarios: DropDown[];
  ddlFornecedores: DropDown[];
  ddlMaquinaEquip: DropDown[];
  ddlCentroCusto: DropDown[];
  idsMaquinaEquip: number[];
  idsCentroCusto: number[];
  idsFuncionarioSolicitante?: number[];
  idsFuncionarioAprovacao?: number[];
  idsFornecedorResponsavel?: number[];
  status?: number[];
  dataDe?: Date | null;
  dataAte?: Date | null;
  nroManutencao?: number | null;
  onDataChange: (de: Date | null, ate: Date | null) => void;
  onMaquinaEquipChange: (ids: number[]) => void;
  onFuncionarioSolicitanteChange: (ids: number[]) => void;
  onFuncionarioAprovacaoChange: (ids: number[]) => void;
  onFornecedorResponsavelChange: (ids: number[]) => void;
  onIdCentroCustoChange: (ids: number[]) => void;
  onNroManutencaoChange: (value: number | null) => void;
  onStatusChange: (ids: number[]) => void;
  onClearFilters: () => void;

};

export const Header = ({
  ddlFuncionarios,
  ddlFornecedores,
  ddlMaquinaEquip,
  idsMaquinaEquip,
  idsFuncionarioSolicitante,
  idsFuncionarioAprovacao,
  idsFornecedorResponsavel,
  status,
  dataDe,
  dataAte,
  ddlCentroCusto,
  nroManutencao,
  idsCentroCusto,
  onIdCentroCustoChange,
  onNroManutencaoChange,
  onDataChange,
  onMaquinaEquipChange,
  onFuncionarioSolicitanteChange,
  onFuncionarioAprovacaoChange,
  onFornecedorResponsavelChange,
  onStatusChange,
  onClearFilters,
}: Props) => {

  const statusOptions = [
    { id: 0, title: "Em Aberto" },
    { id: 1, title: "Andamento" },
    { id: 2, title: "Reprovado" },
    { id: 3, title: "Finalizado" },
  ];

  return (
    <CascateList title="Pesquisar" defaultOpen>
      <div className="w-full p-6 flex flex-col gap-6">
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-6">

          <DefaultMultiAutocomplete
            label='Centro de Custo'
            value={ddlCentroCusto.filter(x => idsCentroCusto?.includes(x.id))}
            options={ddlCentroCusto}
            getOptionLabel={x => x.title}
            getOptionKey={x => x.id}
            onChange={x => onIdCentroCustoChange(x?.map(y => y.id) ?? [])} />



          <DefaultMultiAutocomplete
            label="Maquina / Equipamento"
            options={ddlMaquinaEquip}
            value={ddlMaquinaEquip.filter((i) => idsMaquinaEquip?.includes(i.id))}
            getOptionLabel={(x) => x.title}
            getOptionKey={(x) => x.id}
            onChange={(x) => onMaquinaEquipChange(x?.map(y => y.id) ?? [])}
          />

          <DefaultMultiAutocomplete
            label="Aprovação"
            options={ddlFuncionarios}
            value={ddlFuncionarios.filter((i) => idsFuncionarioAprovacao?.includes(i.id))}
            getOptionLabel={(x) => x.title}
            getOptionKey={(x) => x.id}
            onChange={(x) => onFuncionarioAprovacaoChange(x?.map(y => y.id) ?? [])}
          />

          <DefaultMultiAutocomplete
            label="Status"
            options={statusOptions}
            value={statusOptions?.filter((x) => status?.includes(x.id)) ?? []}
            getOptionLabel={(x) => x.title}
            getOptionKey={(x) => x.id}
            onChange={(x) => onStatusChange(x?.map(y => y.id) ?? [])}
          />
        </div>

        <div className="flex flex-row  gap-3">
          <div className="w-[25%]">
            <DefaultMultiAutocomplete
              label="Solicitante"
              options={ddlFuncionarios}
              value={ddlFuncionarios.filter((i) => idsFuncionarioSolicitante?.includes(i.id))}
              getOptionLabel={(x) => x.title}
              getOptionKey={(x) => x.id}
              onChange={(x) => onFuncionarioSolicitanteChange(x?.map(y => y.id) ?? [])}
            />
          </div>

          <div className="w-[25%]">
            <DefaultMultiAutocomplete
              label="Responsável"
              options={ddlFornecedores}
              value={ddlFornecedores.filter((i) => idsFornecedorResponsavel?.includes(i.id))}
              getOptionLabel={(x) => x.title}
              getOptionKey={(x) => x.id}
              onChange={(x) => onFornecedorResponsavelChange(x?.map(y => y.id) ?? [])}
            />
          </div>

          <div className="w-[30%]">
            <DefaultDateRangePickerInput
              label="Data Solicitação"
              dataDe={dataDe ?? null}
              dataAte={dataAte ?? null}
              onChange={(start, end) => onDataChange(start, end)}
            />
          </div>

          <div className="w-[20%]">
            <MaskedInput
              name={'nroManutencao'}
              label={'Nro da Manutenção'}
              mask="00000000"
              maskPlaceholder="________"
              value={nroManutencao?.toString() ?? null}
              onChange={x => onNroManutencaoChange(x ? parseInt(x) : null)}
            />
          </div>
        </div>

        <div className="flex justify-end">
          <div className="w-[180px]">
            <PrimaryButton
              startIcon={<DynamicIcon nameIcon="ClearRounded" size={25} className="text-black" />}
              buttonColor="yellow"
              onClick={() => onClearFilters()}>

              Limpar filtros
            </PrimaryButton>
          </div>
        </div>
      </div>
    </CascateList>
  );
};
